import React from 'react';
import { connect } from 'react-redux';
import { removeAlert, hideAlert } from 'actions/notifications.js';
import Text from '@bit/knotchinc.web-react-components.text';
import ClickOutside from '@bit/knotchinc.web-react-components.click-outside';
import {
  NotificationDropdownContainer,
  Dropdown,
  DropdownOption,
  DropdownIcon,
} from './styled';

class NotificationDropdown extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  render() {
    const { removeNotification, hideNotification } = this.props;
    return (
      <ClickOutside close={() => this.setState({ isOpen: false })}>
        <NotificationDropdownContainer onMouseLeave={() => this.setState({ isOpen: false })} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
          <Text>•••</Text>
          {this.state.isOpen && <Dropdown>
            <DropdownOption onClick={() => hideNotification()}>
              <DropdownIcon icon="check" />
              <Text verticalAlign="text-top" display="inline-block">Mark as Seen</Text>
            </DropdownOption>
            <DropdownOption onClick={() => removeNotification()}>
              <DropdownIcon icon="close" />
              <Text verticalAlign="text-top" display="inline-block">Remove</Text>
            </DropdownOption>
          </Dropdown>}
        </NotificationDropdownContainer>
      </ClickOutside>);
  }
}

const mapDispatchToProps = (dispatch, { alertId }) => ({
  removeNotification: () => dispatch(removeAlert({ alertId })),
  hideNotification: () => dispatch(hideAlert({ alertId })),
});

export default connect(null, mapDispatchToProps)(NotificationDropdown);
